import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import OmSymbol from "../components/OmSymbol";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4">
      <SEO title="Page Not Found" path="/404" />
      <span className="text-7xl mb-4 flex justify-center text-saffron-500"><OmSymbol size={64} /></span>
      <h1 className="font-heading text-4xl text-maroon-800 mb-3">404 - Page Not Found</h1>
      <p className="text-gray-600 mb-8 max-w-md">The page you're looking for doesn't exist or may have been moved.</p>
      <Link to="/" className="bg-saffron-500 hover:bg-saffron-600 text-white px-7 py-3 rounded-full font-semibold transition-colors">
        Back to Home
      </Link>
    </div>
  );
}
